import * as types from '../../../../types/masters/department/department/departmentTypes';
import * as api from '../../../../../api/masters/department/department/departmentApi';

export const fetchDepartments = () => async (dispatch) => {
  dispatch({ type: types.FETCH_DEPARTMENT_REQUEST });
  try {
    const data = await api.fetchDepartments();
    dispatch({ type: types.FETCH_DEPARTMENT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_DEPARTMENT_FAILURE, payload: error.message });
  }
};

export const addDepartment = (department) => async (dispatch) => {
  try {
    const res = await api.addDepartment(department);
    dispatch({ type: types.ADD_DEPARTMENT_SUCCESS, payload: res });
    dispatch(fetchDepartments());
  } catch (error) {
    dispatch({ type: types.DEPARTMENT_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateDepartment = (id, department) => async (dispatch) => {
  try {
    console.log('Updating department with ID:', id, 'Data:', department);
    const res = await api.updateDepartment(id, department);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_DEPARTMENT_SUCCESS, payload: res });
    dispatch(fetchDepartments());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.DEPARTMENT_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteDepartment = (id) => async (dispatch) => {
  try {
    await api.deleteDepartment(id);
    dispatch({ type: types.DELETE_DEPARTMENT_SUCCESS, payload: id });
    dispatch(fetchDepartments());
  } catch (error) {
    dispatch({ type: types.DEPARTMENT_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setDepartmentEdit = (department) => ({
  type: types.SET_DEPARTMENT_EDIT,
  payload: department,
});

export const clearDepartmentEdit = () => ({
  type: types.CLEAR_DEPARTMENT_EDIT,
}); 